import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { computed } from 'vue'
import { UploadFileState } from '@/types/types'
import useI18nTl from '@/hooks/useI18nTl'

import { defineComponent } from 'vue'

const __default__ = defineComponent({
  name: 'UploadFileStatus',
})

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  state: {
    type: Number,
  },
},
  setup(__props) {

const props = __props

const { t, tl } = useI18nTl('Evses')



const statusLabel = computed(() => {
  switch (props.state) {
    case UploadFileState.UFS_Requesting:
      return t('Base.requesting')
    case UploadFileState.UFS_RequesFailed:
      return t('Base.requesFailed')
    case UploadFileState.UFS_RequesSuccess:
      return t('Base.requesSuccess')
    case UploadFileState.UFS_Uploading:
      return t('Base.uploading')
    case UploadFileState.UFS_UploadFailed:
      return t('Base.uploadFailed')
    case UploadFileState.UFS_Uploaded:
      return t('Base.uploaded')
  }
  return tl('stateNonactivated')
})

const color = computed(() => {
  return '#5e4eff'
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("span", {
    class: "text-status",
    style: _normalizeStyle({ color: _unref(color) })
  }, _toDisplayString(_unref(statusLabel)), 5))
}
}

})